import { toNumberCommas } from '@/utils/string-helpers';
import { useBasicMetas } from '../_utils/use-basic-metas';
import { usePageTitle } from '../_utils/use-page-title';
import usePLPData from '../_utils/use-plp-data';
const PLPPageTitle = () => {
  const title = usePageTitle();
  const {
    pageResponse
  } = usePLPData();
  const totalCount = pageResponse?.products?.totalCount;
  const isLoadingBasicMetas = useBasicMetas().isLoadingBasicMetas;
  if (isLoadingBasicMetas) return <div className='mb-3 h-6 w-full animate-pulse rounded-md bg-gray-100 lg:mb-0 lg:h-9 lg:w-30' />;
  return <div className='mb-3 flex items-center gap-2 lg:mb-0 lg:gap-3' data-sentry-component="PLPPageTitle" data-sentry-source-file="plp-page-title.tsx">
            <h1 className='text-body-14 font-bold text-text-black lg:text-body-16'>{title}</h1>
            <span className='text-body-14 text-text-darkGray lg:text-body-16'>
                (<span data-test='plp-total-count'>{toNumberCommas(totalCount || 0)}</span> کالا)
            </span>
        </div>;
};
export default PLPPageTitle;